export const BadgeStatus = (props) => {
  // input
  const { status = null} = props;

  switch(status?.toUpperCase()) {
    case 'ACTIVE': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 shadow-sm ring-1 ring-inset ring-green-600/20">
        Active
      </span>
    )
    case 'REGISTRATION:PENDING_APPROVAL': return (
      <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 shadow-sm ring-1 ring-inset ring-yellow-600/20">
        Pending Approval
      </span>
    )
    default: return (
      <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 shadow-sm ring-1 ring-inset ring-gray-500/10">
        {status ? status : 'Unknown'}
      </span>
    )
  }
}
export const BadgeActive = (props) => {
  const { active = false } = props;
  // handles boolean true OR string "true" (DynamoDB stores it as a String)
  const isActive = active === true || String(active).toLowerCase() === 'true';

  return isActive ? (
    <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 shadow-sm ring-1 ring-inset ring-green-600/20">
      Active
    </span>
  ) : (
    <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 shadow-sm ring-1 ring-inset ring-red-600/20">
      Inactive
    </span>
  );
};
